export default __webpack_public_path__ + "static/media/compactor.0d59f012.jpg";